import { Button, FormControlLabel, FormGroup, Grid, Switch } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { RootState } from '../../reducers';
import { closeEditHandler, handleSaveRole, setRolePermissions, setSelectAllPermissions } from '../../store/adminRoles.slice';

const Permissions = (props) => {
    const dispatch = useAppDispatch();

    const { permissions } = useSelector((state: RootState) => state.shared);
    const { openNew, selectedRole, selectAllPermissions, rolePermissions } = useSelector((state: RootState) => state.adminRoles);

    const uniquePermissions = useMemo(() => {
        const seen = new Set<string>();
        return permissions.filter((permission) => {
            if (!permission?.Name || seen.has(permission.Name)) {
                return false;
            }
            seen.add(permission.Name);
            return true;
        });
    }, [permissions]);

    const selectAllHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            dispatch(setSelectAllPermissions(true));
            dispatch(setRolePermissions([...uniquePermissions]));
        } else {
            dispatch(setSelectAllPermissions(false));
            dispatch(setRolePermissions([]));
        }
    };

    const permissionHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.value;
        const alreadyAssigned = rolePermissions.some((perm) => perm.Name === name);
        if (alreadyAssigned) {
            dispatch(setRolePermissions(rolePermissions.filter((perm) => perm.Name !== name)));
            return;
        }

        const catalogPermission = uniquePermissions.find((perm) => perm.Name === name);
        dispatch(setRolePermissions([...rolePermissions, { Name: name, Id: catalogPermission?.Id || e.target.id }]));
    };

    useEffect(() => {
        const assignedNames = new Set(rolePermissions.map((perm) => perm.Name));
        const allSelected = uniquePermissions.length > 0 && uniquePermissions.every((perm) => assignedNames.has(perm.Name));
        dispatch(setSelectAllPermissions(allSelected));
    }, [rolePermissions, uniquePermissions, dispatch]);

    return (
        <Grid size={12}>
            <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid size={12}>
                    {/* <Typography component={'h5'}>Permissions</Typography> */}
                    <FormControlLabel
                        disabled={selectedRole.Name.length === 0 && !openNew ? true : false}
                        label="Select All Permissions"
                        control={<Switch checked={selectAllPermissions} onChange={selectAllHandler} />}
                    />
                </Grid>

                <Grid size={12}>
                    <FormGroup sx={{ padding: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        {uniquePermissions.map((el) => {
                            return (
                                <Grid size={4} key={el.Id}>
                                    <FormControlLabel
                                        label={el.Name}
                                        control={
                                            <Switch
                                                id={el.Id}
                                                checked={rolePermissions.some((perm) => perm.Name === el.Name)}
                                                disabled={selectedRole.Name.length === 0 && !openNew ? true : false}
                                                value={el.Name}
                                                onChange={permissionHandler}
                                            />
                                        }
                                    />
                                </Grid>
                            );
                        })}
                    </FormGroup>
                </Grid>
                <Grid size={12} display="flex" justifyContent={'flex-end'}>
                    <Button
                        className="button-120"
                        sx={{ marginRight: 2 }}
                        disabled={selectedRole.Name.length === 0 && !openNew ? true : false}
                        variant="contained"
                        onClick={() => dispatch(handleSaveRole())}
                    >
                        Save
                    </Button>
                    <Button className="button-120" variant="contained" onClick={() => dispatch(closeEditHandler())}>
                        Cancel
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Permissions;
